import { useEffect, useRef } from "react";

import PopupCom from "@/component/popupCom";
import { trackGdp } from "../../../../utils/gio-report";

import "./index.less";
import { useGoodsFocus } from "../tab-goods-content/GoodsFocusContext";
import { entry } from "../../utils";
import { processOssImage } from "@/utils/image";
import { useUserContext } from "../../routes/home/userContext";
import { useMount } from "ahooks";
import { Image, Skeleton } from "antd-mobile";

const AgreementRow = () => {
  const { buyAgreement, detailRule, credit } = useGoodsFocus();

  const BuyAgreementRef = useRef<any>(null);
  const RulePopupRef = useRef<any>(null);

  const { levelInfo } = useUserContext();

  const isCarOwner = levelInfo?.memberType === 1;
  const showCredit = isCarOwner || (!isCarOwner && credit && credit > 0);

  useEffect(() => {
    if (!levelInfo?.level) return;
    trackGdp("P11222", "B034", {
      var_ch: entry,
      vip_level: levelInfo?.level ? `V${levelInfo?.level}` : "V0",
    });
  }, [levelInfo]);

  useMount(() => {
    trackGdp("P11222", "B013", {
      var_ch: entry,
      vip_level: levelInfo?.level ? `V${levelInfo?.level}` : "V0",
      points: credit,
    });
  });

  const goToRule = () => {
    RulePopupRef.current?.onOpen();
  };

  const goToAgreement = () => {
    BuyAgreementRef.current?.onOpen();
  };

  return (
    <div className="agreement-row">
      <div className={`privacy-row`}>
        支付即同意
        <span onClick={goToAgreement}>《购买协议》</span>
        <div className="devide-line"></div>
        <span className="rule" onClick={goToRule}>
          详细规则
        </span>
        {showCredit ? (
          <span className="value">{`我的剩余积分：${credit || 0}`}</span>
        ) : null}
      </div>
      {buyAgreement && (
        <PopupCom ref={BuyAgreementRef} title="购买协议" height={"auto"}>
          <div className="agreement-popup-content">
            <Image
              alt=""
              className="popup-img"
              src={processOssImage(buyAgreement)}
              placeholder={
                <Skeleton animated style={{ width: "100vw", height: "70vh" }} />
              }
            />
          </div>
        </PopupCom>
      )}
      {detailRule && (
        <PopupCom ref={RulePopupRef} title="详细规则" height={"auto"}>
          <div className="agreement-popup-content">
            <Image
              alt=""
              className="popup-img"
              src={processOssImage(detailRule)}
              placeholder={
                <Skeleton animated style={{ width: "100vw", height: "70vh" }} />
              }
            />
          </div>
          {}
        </PopupCom>
      )}
    </div>
  );
};

export default AgreementRow;
